// Types
import { Country, State } from '@/types/formOptions';

export type MemberDetails = {
  CITY: string;
  COUNTRY: Country;
  EMAIL: string;
  FIRSTNAME: string;
  INFORMALNAME: string;
  LASTNAME: string;
  MEMBERNUMBER: number;
  MIDDLENAME: string;
  PAIDTHRU: string;
  PHONE: string;
  REGIONID: number;
  REGIONCODE: string;
  REGIONNAME: string;
  STATE_PROVINCE: State;
  STATE_PROVINCE_ABBR: string;
  STREET1: string;
  STREET2: string | null;
  ZIP: string;
};

export type PrimaryEntrantDetails = {
  ADDRESS2: string;
  ADDRESS: string;
  AGE_RANGE_ID: number;
  CELL_PHONE: string;
  CITY: string;
  COST: number;
  COUNTRY: string;
  DAYTIME_PHONE: string | null;
  EMAIL: string;
  EMERGENCYCONTACTNAME: string;
  EMERGENCYCONTACTPHONE: string;
  ENTRANT_NUMBER: string | null;
  ENTRANT_TYPE_ID: number;
  ENTRY_DATE: string;
  FIRSTPARADE: number
  FIRST_NAME: string;
  GENDER_ID: 1 | 2 | 3 | null;
  ID: number;
  IS_ACTIVE: number;
  IS_PARENT: number;
  IS_VISIBLE: number;
  LAST_NAME: string;
  MEMBERNUMBER: number;
  MOBILITYDEVICE: number
  NAME_BADGE: string;
  NIGHT_PHONE: string | null;
  PARENT_ENTRANT_ID: number;
  PCA_TITLE: string;
  PHASE1PAID: 1 | null;
  REGION: number;
  RELATION_TO_ENTRANT: string | null;
  STATE: string;
  ZIP: string;
};

export type PCAJuniorDetails = {
  BIRTHMONTH: number;
  BIRTHYEAR: number;
  CITY: string;
  COUNTRY: string;
  COUNTRY_ABBR: string;
  FIRSTNAME: string;
  JUNIORREGIONLOC: string;
  LASTNAME: string;
  PARENTMEMBERNUMBER: number;
  PCAJUNIORID: number;
  RELATIONSHIPID: number;
  STATE: string;
  STATE_ABBR: string;
  STREET2: string | null;
  STREETADDRESS: string;
  ZIP: string;
};

// @ZACK - this should prob live in the forms.ts types file - moving it will require refactoring a ton of imports
export enum FormType {
  PRIMARY_ENTRANT = 'primaryEntrant',
  CO_ENTRANT = 'coEntrant',
  CHILD = 'child',
  GUEST = 'guest',
  CAR = 'car',
  EVENT = 'event',
  MEAL = 'meal',
}

export type PaymentSummaryEventItem = {
  entrantName: string;
  entrantId: number,
  eventName: string;
  eventId: number;
  paid: boolean;
  price: number;
  carId: number; // 0 if event doesn't require a car
  formType: FormType;
  seatsAvailable: number; // 0 or negative number means the event sold out (for over sale detection)
};

export type PaymentSummaryMealItem = {
  entrantName: string;
  entrantId: number;
  mealId: number;
  mealName: string;
  paid: boolean;
  price: number;
  formType: FormType;
};

export type PaymentSummaryEntrantItem = {
  id: number;
  firstName: string;
  lastName: string;
  paid: boolean;
  price: number;
  formType: FormType;
};

export type PaymentSummaryCarItem = {
  year: number;
  modelName: string;
  color: string;
  carId: number;
  price: number;
  paid: boolean;
  isPorsche: boolean;
  MEMBERCAR_ID: number;
  legal: boolean;
  formType: FormType;
};

export type PaymentSummaryItem = PaymentSummaryEntrantItem | PaymentSummaryEventItem | PaymentSummaryMealItem | PaymentSummaryCarItem;

export type PaymentSummary = {
  [FormType.PRIMARY_ENTRANT]: PaymentSummaryEntrantItem[];
  [FormType.CO_ENTRANT]: PaymentSummaryEntrantItem[];
  [FormType.CHILD]: PaymentSummaryEntrantItem[];
  [FormType.GUEST]: PaymentSummaryEntrantItem[];
  [FormType.EVENT]: PaymentSummaryEventItem[];
  [FormType.MEAL]: PaymentSummaryMealItem[];
  [FormType.CAR]: PaymentSummaryCarItem[];
};

// { [FormType: string]: <total cost by quantity> }
export type TotalsByRegistrationFormType = {
  [FormType.PRIMARY_ENTRANT]: number,
  [FormType.CO_ENTRANT]: number,
  [FormType.CHILD]: number,
  [FormType.GUEST]: number,
};

// { [CompletionProgressFormType: string]: <has the user completed or intensionally skipped the form> }
export enum CompletionProgressFormType {
  PRIMARYENTRANT = 'PRIMARYENTRANT',
  CHILD = 'CHILD',
  COENTRANT = 'COENTRANT',
  GUEST = 'GUEST',
  CHECKOUT = 'CHECKOUT',
}

export type CompletionProgress = {
  [CompletionProgressFormType.CHECKOUT]: boolean,
  [CompletionProgressFormType.COENTRANT]: boolean,
  [CompletionProgressFormType.GUEST]: boolean,
  [CompletionProgressFormType.CHILD]: boolean,
  [CompletionProgressFormType.PRIMARYENTRANT]: boolean,
};